/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsToggleDocumentUnread204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsToggleDocumentUnread505Schema = z.any();

export const optionsToggleDocumentUnreadMutationResponseSchema = z.lazy(() => optionsToggleDocumentUnread204Schema);
